// Tetikleyicinin cok dilli [{code, content}] alanindan ziyaretciye gosterilecek icerigi secer.
// CommonJS: webpack de node --test de okuyabilsin diye.

// Panel her sistem dili icin kayit yazar; doldurulmayan dil "" ya da quill'in bos ciktisi olarak gelir.
function isBlank(content) {
    return typeof content !== "string" || !content.replace(/<p><br><\/p>/g, "").trim();
}

// Sira: secili dil -> tarayici dili -> ilk dolu dil. Bos kayit "var" sayilmaz, yoksa balon basliga duser.
function pickLangContent(list, lang, navigatorLang) {
    const filled = Array.isArray(list) ? list.filter((x) => x && !isBlank(x.content)) : [];
    const byCode = (code) => (code ? filled.find((x) => x.code === code) : undefined);
    const hit = byCode(lang) || byCode(navigatorLang) || filled[0];
    return hit ? hit.content : "";
}

// Baslik: cok dilli titles varsa dile gore, yoksa eski kayitlarin duz string title'i.
function pickTriggerTitle(trigger, lang, navigatorLang) {
    const t = trigger || {};
    return pickLangContent(t.titles, lang, navigatorLang) || (typeof t.title === "string" ? t.title : "");
}

module.exports = { pickLangContent, pickTriggerTitle, isBlank };



// WEBPACK FOOTER //
// ./src/utils/triggerContent.js